import { render, staticRenderFns } from "./FindingsPreference.vue?vue&type=template&id=2e70f2a6&scoped=true&"
import script from "./FindingsPreference.vue?vue&type=script&lang=js&"
export * from "./FindingsPreference.vue?vue&type=script&lang=js&"
import style0 from "./FindingsPreference.vue?vue&type=style&index=0&id=2e70f2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e70f2a6",
  null
  
)

export default component.exports